module.exports = __webpack_public_path__ + "static/accounts_vault_aws_1-e8de8f825b9eedcd570a7c7a0ef654fe.png";